import { useState, useEffect } from 'react';

import { useStaticQuery, graphql } from 'gatsby';

const useCartFlyout = () => {
	const { wp } = useStaticQuery(
		graphql`
			{
				wp {
					globalSettings {
						acfGlobalSettings {
							shoppingCartOffline
						}
					}
				}
			}
		`
	);

	const isShoppingCartOffline = wp.globalSettings.acfGlobalSettings.shoppingCartOffline?.[0] === 'true';
	const [isCartFlyoutOpen, setIsCartFlyoutOpen] = useState(false);
	const [cartError, setCartError] = useState({
		visible: false,
		errorHeading: '',
		errorBody: '',
		errorEmail: '',
	});

	const cartFlyoutOpen = () => {
		setIsCartFlyoutOpen(() => true);
	};

	const cartFlyoutClose = async() => {
		setIsCartFlyoutOpen(() => false);
	};

	useEffect(() => {
		if (cartError.visible) {
			setIsCartFlyoutOpen(() => true);
		}
  	}, [cartError]) // eslint-disable-line

	return {
		isShoppingCartOffline,
		isCartFlyoutOpen,
		cartFlyoutOpen,
		cartFlyoutClose,
		cartError,
		setCartError,
	};
};

export default useCartFlyout;
